import type { SxProps, Theme } from '@/shared/ui/mui';

export const dashTokens = {
  bgPage: '#F1F5F9',
  bgSurface: '#FFFFFF',
  bgElevated: '#F8FAFC',
  borderSubtle: 'rgba(15, 23, 42, 0.10)',
  borderStrong: 'rgba(15, 23, 42, 0.18)',
  shadowSm: '0 2px 8px rgba(16,24,40,0.08), 0 1px 3px rgba(16,24,40,0.06)',
  shadowMd: '0 6px 18px rgba(16,24,40,0.10), 0 2px 6px rgba(16,24,40,0.06)',
  radius: { card: 3, section: 2 },
  contentPadding: { xs: 2, sm: 3 },
} as const;

export const surfaceCardSx: SxProps<Theme> = {
  bgcolor: dashTokens.bgSurface,
  border: `1px solid ${dashTokens.borderSubtle}`,
  boxShadow: dashTokens.shadowSm,
  borderRadius: dashTokens.radius.section,
};
